/**
 * **A choice answer drawn as its picked options, one chip each.** Which answers get chips, and in
 * which order, is `model/surveyChoiceList`'s decision; this only draws them.
 *
 * The chips are for the eye and are hidden from assistive technology. The answer's own words stand
 * beside them, visually hidden, so a screen reader hears exactly what it heard before the chips
 * existed — one sentence rather than a run of separate fragments.
 */

import hidden from '~/shared/ui/visuallyHidden.module.css';

import type { SurveyChoiceListView } from '../model/surveyChoiceList';
import styles from './SurveyChoiceList.module.css';

interface SurveyChoiceListProps {
  readonly choice: SurveyChoiceListView;
  /** The answer in words — the cell's `text`. What a screen reader reads in the chips' place. */
  readonly text: string;
}

export function SurveyChoiceList({ choice, text }: SurveyChoiceListProps) {
  return (
    <>
      <span className={styles.list} aria-hidden="true">
        {choice.items.map((item) => (
          <span key={item.key} className={styles.chip}>
            {item.label}
          </span>
        ))}
      </span>
      <span className={hidden.srOnly}>{text}</span>
    </>
  );
}
